/** Parse thông tin bên thuê lưu trong notes hoặc metadata hợp đồng */
export interface TenantContractInfo {
  name?: string;
  cccd?: string;
  dateOfBirth?: string;
  address?: string;
  phone?: string;
}

function parseContractDateParts(value?: string | null): { day: string; month: string; year: string } | null {
  if (!value) return null;

  const trimmed = String(value).trim();
  if (!trimmed) return null;

  const isoMatch = trimmed.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (isoMatch) {
    const [, year, month, day] = isoMatch;
    return { day, month, year };
  }

  const vnMatch = trimmed.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})/);
  if (vnMatch) {
    const [, day, month, year] = vnMatch;
    return {
      day: day.padStart(2, '0'),
      month: month.padStart(2, '0'),
      year,
    };
  }

  const parsed = new Date(trimmed);
  if (Number.isNaN(parsed.getTime())) return null;

  return {
    day: String(parsed.getDate()).padStart(2, '0'),
    month: String(parsed.getMonth() + 1).padStart(2, '0'),
    year: String(parsed.getFullYear()),
  };
}

export function formatContractDisplayDate(value?: string | null): string {
  const parts = parseContractDateParts(value);
  if (!parts) return value?.trim() || '';
  return `${parts.day}/${parts.month}/${parts.year}`;
}

/** Định dạng ngày tháng năm cho văn bản hợp đồng: "28 tháng 07 năm 2026" */
export function formatContractLegalDate(value?: string | null): string {
  const parts = parseContractDateParts(value);
  if (!parts) return value?.trim() || '';
  return `${parts.day} tháng ${parts.month} năm ${parts.year}`;
}

export function parseContractNotes(notes?: string | null): Pick<TenantContractInfo, 'cccd' | 'dateOfBirth' | 'address' | 'phone'> {
  if (!notes) return {};

  return {
    cccd: notes.match(/CCCD:\s*([^|]+)/i)?.[1]?.trim(),
    dateOfBirth: notes.match(/Ngày sinh:\s*([^|]+)/i)?.[1]?.trim(),
    address: notes.match(/Địa chỉ:\s*([^|]+)/i)?.[1]?.trim(),
    phone: notes.match(/SĐT:\s*([^|]+)/i)?.[1]?.trim(),
  };
}

export function resolveTenantContractInfo(source: {
  tenant_name?: string | null;
  tenant_cccd?: string | null;
  tenant_date_of_birth?: string | null;
  tenant_address?: string | null;
  tenant_phone?: string | null;
  notes?: string | null;
}): TenantContractInfo {
  const fromNotes = parseContractNotes(source.notes);

  return {
    name: source.tenant_name?.trim() || undefined,
    cccd: source.tenant_cccd?.trim() || fromNotes.cccd || undefined,
    dateOfBirth: source.tenant_date_of_birth?.trim() || fromNotes.dateOfBirth || undefined,
    address: source.tenant_address?.trim() || fromNotes.address || undefined,
    phone: source.tenant_phone?.trim() || fromNotes.phone || undefined,
  };
}
